export default __webpack_public_path__ + "static/header-dxbot-839cee157ad7402b963dc1b8f7710279.svg";